<template>
  <v-autocomplete
    outlined
    dense
    :label="$tc(partTranslationKey + '.self', 2)"
    :items="parts"
    v-model="localPart"
    :item-text="v => v.ratio ? `${v.name} (${v.ratio}%) - ${v.formattedPrice}` : v.name"
    item-value="id"
    @input="v => $emit('input', v)"
    :disabled="disabled"
    return-object
    :item-disabled="i => i.remainingValue === 0 || i.disabled"
    :multiple="multiple"
    :chips="multiple"
    :small-chips="multiple"
    :deletable-chips="multiple"
    @change="validationModel && validationModel.$touch()"
    :error-messages="errorMessages"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.ratio ? `${item.name} (${item.ratio}%)` : item.name }}</v-list-item-title>
      <v-list-item-subtitle v-if="item.id && item.remainingValue">{{ $t('payment.milestone.partSubtitleRemainingValue', item) }}</v-list-item-subtitle>
      <v-list-item-subtitle v-if="item.id && !item.remainingValue">{{ $t('payment.milestone.partSubtitle', item) }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:append-outer>
      <v-btn
        v-if="multiple"
        icon
        @click="$emit(allSelected ? 'unselect-all' : 'select-all')"
      >
        <v-icon>{{allSelected ? 'mdi-checkbox-multiple-marked-outline' : 'mdi-checkbox-multiple-blank-outline'}}</v-icon>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
import { getLocalizationContext } from '@/helpers/translations'

export default {
  name: 'PartsSelect',
  props: {
    value: [Object, Array],
    parts: Array,
    disabled: Boolean,
    multiple: Boolean,
    errorMessages: Array,
    validationModel: Object,
    isMultiCurrency: Boolean
  },
  data () {
    return {
      localPart: this.multiple ? [...(this.value || [])] : { ...(this.value || {}) }
    }
  },
  computed: {
    allSelected () {
      return this.parts.length === this.value.length
    },
    partTranslationKey () {
      return getLocalizationContext(this.isMultiCurrency)
    }
  },
  watch: {
    value (v) {
      this.localPart = this.multiple ? [...v] : { ...v }
    }
  }
}
</script>
